/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import SwitchField from "components/SwitchField";
import Footer from "./footer";
import DatePicker from "react-flatpickr";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import { v4 as uuidV4 } from "uuid";
import { Vietnamese } from "flatpickr/dist/l10n/vn";
const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
  fontSize: 13,
};
const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
  whiteSpace: "nowrap",
};
const selectStyle = {
  minWidth: 200,
  fontSize: 13,
  color: "#495057",
  border: "0.0625rem solid #d2d6da",
  background: "#fff",
  padding: "0.5rem 0.75rem",
  width: "100%",
  borderRadius: "0.5rem",
};
const Td = ({ children, style, ...rest }) => {
  return (
    <td {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </td>
  );
};

export default function TaxPersonalTable({ formData, setFieldValue }) {
  const [data, setData] = useState([
    {
      id: uuidV4(),
      city: "",
      district: "",
      ward: "",
      village: "",
      road: "",
      apartment: "",
      landPlotNo: "",
      mapSheetNo: "",
      acreage: "",
      soilType: "",
      landClass: "",
      taxRates: "",
      riceTax: 0,
    },
  ]);
  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);
  const handleChange = (values) => {
    const { id, name, value, type } = values;
    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      })
    );
    console.log({ id, name, value, type, data });
  };
  const handleChangeDate = (date, id) => {
    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, date };
        }
        return item;
      })
    );
  };
  const handleChangeSelect = (id, name, value) => {
    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      })
    );
  };
  const handleAdd = () => {
    setData((prev) => [
      ...prev,
      {
        id: uuidV4(),
        city: "",
        district: "",
        ward: "",
        village: "",
        road: "",
        apartment: "",
        landPlotNo: "",
        mapSheetNo: "",
        acreage: "",
        soilType: "",
        landClass: "",
        taxRates: "",
        riceTax: 0,
      },
    ]);
  };
  const handleDelete = (id) => {
    setData((prev) => prev.filter((item) => item.id !== id));
  };

  return (
    <Box display="flex" flexDirection="column" mt={5} style={{ marginBottom: 30 }}>
      <Box>
        <table style={tableStyle}>
          <tbody>
            <tr>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                STT
              </Td>
              <Td rowSpan={1} colSpan={6} style={{ textAlign: "center" }}>
                Địa chỉ thửa đất
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Thửa đất số
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Tờ bản đồ số
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Diện tích (ha)
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Loại đất
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Hạng đất
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Định suất thuế (kg thóc/ha)
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Thuế tính bằng thóc (kg)
              </Td>
            </tr>
            <tr>
              <Td style={{ textAlign: "center" }}>Tỉnh/Thành phố</Td>
              <Td style={{ textAlign: "center" }}>Quận/huyện</Td>
              <Td style={{ textAlign: "center" }}>Phường/xã/thị trấn</Td>
              <Td style={{ textAlign: "center" }}>Tổ/thôn</Td>
              <Td style={{ textAlign: "center" }}>Đường/phố</Td>
              <Td style={{ textAlign: "center" }}>Số nhà</Td>
            </tr>
            <tr>
              <Td style={{ textAlign: "center" }}></Td>
              <Td style={{ textAlign: "center" }}>[10.6]</Td>
              <Td style={{ textAlign: "center" }}>[10.5]</Td>
              <Td style={{ textAlign: "center" }}>[10.4]</Td>
              <Td colSpan={3} style={{ textAlign: "center" }}>
                [10.1]
              </Td>
              <Td style={{ textAlign: "center" }}>[11]</Td>
              <Td style={{ textAlign: "center" }}>[12]</Td>
              <Td style={{ textAlign: "center" }}>[13]</Td>
              <Td style={{ textAlign: "center" }}>[14]</Td>
              <Td style={{ textAlign: "center" }}>[15]</Td>
              <Td style={{ textAlign: "center" }}>[16]</Td>
              <Td style={{ textAlign: "center" }}>[17]=[13]x[16]</Td>
            </tr>
            {data.map((item, index) => (
              <tr key={item.id}>
                <Td className="toggle-button" style={{ textAlign: "center" }}>
                  {index + 1}
                  <div className="button-action delete">
                    <button type="button" onClick={() => handleDelete(item.id)}>
                      Xóa dòng
                    </button>
                  </div>
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) => handleChangeSelect(item.id, "city", e.target.value)}
                  >
                    <option value="value1">Thành phố A</option>
                    <option value="value2">Thành phố B</option>
                    <option value="value3">Thành phố C</option>
                    <option value="value4">Thành phố D</option>
                  </select>
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) => handleChangeSelect(item.id, "district", e.target.value)}
                  >
                    <option value="value1">Quận A</option>
                    <option value="value2">Quận B</option>
                    <option value="value3">Quận C</option>
                    <option value="value4">Quận D</option>
                  </select>
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) => handleChangeSelect(item.id, "ward", e.target.value)}
                  >
                    <option value="value1">Phường A</option>
                    <option value="value2">Phường B</option>
                    <option value="value3">Phường C</option>
                    <option value="value4">Phường D</option>
                  </select>
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="village"
                    value={item.village}
                    onChange={handleChange}
                  />
                </Td>
                <Td>
                  <InputTable id={item.id} name="road" value={item.road} onChange={handleChange} />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="apartment"
                    value={item.apartment}
                    onChange={handleChange}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="landPlotNo"
                    value={item.landPlotNo}
                    onChange={handleChange}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="mapSheetNo"
                    value={item.mapSheetNo}
                    onChange={handleChange}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="acreage"
                    value={item.acreage}
                    onChange={handleChange}
                  />
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) => handleChangeSelect(item.id, "soilType", e.target.value)}
                  >
                    <option value="value1">Đất trồng lúa</option>
                    <option value="value2">Đất trồng cây ăn quả</option>
                  </select>
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) => handleChangeSelect(item.id, "landClass", e.target.value)}
                  >
                    <option value="value1">Hạng 1</option>
                    <option value="value2">Hạng 2</option>
                  </select>
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="taxRates"
                    value={item.taxRates}
                    onChange={handleChange}
                  />
                </Td>
                <Td
                  style={{
                    background: "#ddeff3",
                  }}
                >
                  <InputTable
                    style={{
                      background: "#ddeff3",
                      border: 0,
                      textAlign: "right",
                    }}
                    readOnly={true}
                    id={item.id}
                    name="riceTax"
                    value={item.riceTax}
                    onChange={handleChange}
                  />
                </Td>
              </tr>
            ))}
          </tbody>
        </table>
      </Box>
      <SoftBox display="flex" justifyContent="flex-start" gap={3} mt={2}>
        <SoftButton variant="gradient" color="dark" onClick={handleAdd}>
          Thêm dòng
        </SoftButton>
      </SoftBox>
    </Box>
  );
}

function InputTable(props) {
  const { id, onChange, type = "text", ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    if (name === "number") {
      const newValue = value === "0" ? "" : value;
      if (!regexNumber.test(newValue)) return;
      onChange({ id, value: newValue !== "" ? +newValue : "", name, type });
    }
    if (type === "text" && name !== "number") {
      onChange({ id, value, name, type });
    }
  }
  return (
    <input
      type={type}
      style={{
        textAlign: "left",
        fontSize: 13,
        color: "#495057",
        border: "0.0625rem solid #d2d6da",
        background: "#fff",
        padding: "0.5rem 0.75rem",
        width: "100%",
        borderRadius: "0.5rem",
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
